import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import AppFunction from "../../../core/helpers/app/AppFunction";
import {TENANTS} from "../../Config/ApiUrl";

import {axiosDelete, axiosPatch, axiosPost, urlGenerator} from "../../../common/Helper/AxiosHelper";
// import {TENANT_USERS} from "../../../common/Config/apiUrl";
import {calenderTime, formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            isModalActive: false,
            isTenantCreateOpenModalActive: false,
            promptIcon: '',
            promptTitle: '',
            promptMessage: '',
            modalClass: '',
            confirmationModalActive: false,
            promptAction: '',
            tenant: '',
            selectedUrl: '',
            tenantId: '',
            loading: false,
            attendanceModalActive: false,
            leaveModalActive: false,
            isResourceLogModalActive: false,
            isJobHistoryEditModalActive: false,
            modalAction: '',
            options: {
                name: this.$allLabel('tenant'),
                url: TENANTS,
                showCount: true,
                showClearFilter: true,
                responsive: true,
                enableCookie: false,
                enableRowSelect: true,
                columns: [
                    {
                        title: this.$t('name'),
                        type: 'custom-html',
                        key: 'name',
                        modifier: (value, row) => {
                            return row.name;
                        }
                    },
                    {
                        title: this.$t('email'),
                        type: 'custom-html',
                        key: 'email',
                        modifier: (value, row) => {
                            return row.email;
                        }
                    },
                    {
                        title: this.$t('legal_name'),
                        type: 'custom-html',
                        key: 'legal_name',
                        isVisible: false,
                        modifier: (value, row) => {
                            return row.legal_name;
                        }
                    },
                    {
                        title: this.$t('email'),
                        type: 'custom-html',
                        isVisible: false,
                        key: 'email',
                        modifier: (value, row) => {
                            return row.email;
                        }
                    },
                    {
                        title: this.$t('status'),
                        type: 'component',
                        componentName: 'app-tenant-status',
                        key: 'active',
                        isVisible: 'true',
                    },
                    {
                        title: this.$t('subscription'),
                        type: 'custom-html',
                        key: 'subscription',
                        isVisible: 'true',
                        modifier: (value, row) => {
                            return value ? value.name : '-';
                        }
                    },
                    {
                        title: this.$t('company_size'),
                        type: 'custom-html',
                        key: 'company_size',
                        isVisible: 'true',
                        modifier: (value, row) => {
                            return row ? row.company_size : '-';
                        }
                    },
                    {
                        title: this.$t('industry_type'),
                        type: 'custom-html',
                        key: 'industry_type',
                        isVisible: 'true',
                        modifier: (value, row) => {
                            return row ? row.industry_type : '-';
                        }
                    },
                    {
                        title: this.$t('ends_at'),
                        type: 'component',
                        key: 'subscription',
                        componentName: 'app-tenant-subscription-status',
                        isVisible: 'true',
                    },
                    {
                        title: this.$t('billing_cycle'),
                        type: 'custom-html',
                        key: 'subscription',
                        isVisible: 'true',
                        modifier: (value, row) => {
                            return value ? value.billing_cycle : '-';
                        }
                    },
                    {
                        title: this.$t('resources'),
                        type: 'component',
                        key: 'subscription',
                        isVisible: 'true',
                        componentName: 'app-tenant-resource-button'
                    },
                    {
                        title: this.$t('description'),
                        type: 'custom-html',
                        key: 'description',
                        isVisible: false,
                        modifier: (value, row) => {
                            return row ? row.description : '-';
                        }
                    },
                    {
                        title: this.$t('external_url'),
                        type: 'custom-html',
                        key: 'external_url',
                        isVisible: false,
                        modifier: (value, row) => {
                            return row ? row.external_url : '-';
                        }
                    },
                    {
                        title: this.$t('created_at'),
                        type: 'custom-html',
                        key: 'created_at',
                        // isVisible: false,
                        uniqueKey: 'id',
                        modifier: function (created_at, rowData) {
                            return formatDateToLocal(created_at)
                        }
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ],
                filters: [
                    {
                        title: this.$t('created'),
                        type: "range-picker",
                        key: "date",
                        option: ["today", "thisMonth", "last7Days", "thisYear"]
                    },
                    {
                        title: this.$t('status'),
                        // type: "multi-select-filter",
                        type: "dropdown-menu-filter",
                        key: "active",
                        // option: [{"name" : "True", "value": "true"}, {"name" : "False", "value": "false"} ],
                        option: [{
                            id: "true",
                            value: this.$t("active")
                        }, {
                            id: "false",
                            value: this.$t("inactive")
                        }],
                    },
                    // {
                    //     title: this.$t('department'),
                    //     type: "multi-select-filter",
                    //     key: "departments",
                    //     option: [],
                    //     listValueField: 'name',
                    //     permission: !!this.$can('view_departments')
                    // },
                    // {
                    //     title: this.$t('work_shift'),
                    //     type: "multi-select-filter",
                    //     key: "working_shifts",
                    //     option: [],
                    //     listValueField: 'name',
                    //     permission: !!this.$can('view_working_shifts')
                    // },
                    // {
                    //     title: this.$t('role'),
                    //     type: "multi-select-filter",
                    //     key: "roles",
                    //     option: [],
                    //     listValueField: 'name',
                    //     permission: !!this.$can('view_roles')
                    // },
                    // {
                    //     title: this.$t('gender'),
                    //     type: "checkbox",
                    //     key: "gender",
                    //     option: [
                    //         {id: 'male', value: this.$t('male')},
                    //         {id: 'female', value: this.$t('female')},
                    //         {id: 'other', value: this.$t('other')}
                    //     ],
                    //     permission: !!this.$can('view_employees')
                    // },
                    // {
                    //     title: this.$t("salary"),
                    //     type: "range-filter",
                    //     key: "salary",
                    //     minTitle: this.$t("minimum_salary"),
                    //     maxTitle: this.$t("maximum_salary"),
                    //     maxRange: 100,
                    //     minRange: 0
                    // }
                ],
                actionType: "dropdown",
                actions: [
                    // {
                    //     title: this.$t('view_details'),
                    //     key: "view_details",
                    // },
                    {
                        title: this.$t('edit'),
                        url: TENANTS,
                        key: "edit",
                        modifier: row => {
                            return this.$can('update_tenants') && (this.$isSuperAdmin());
                        },
                    },
                    // {
                    //     title: this.$t('add_attendance'),
                    //     key: "add_attendance",
                    //     modifier: (row) => this.$can('update_attendance_status')
                    //         && row.employment_status?.alias !== 'terminated'
                    //         && row.status.name !== 'status_inactive'
                    // },
                    // {
                    //     title: this.$t('assign_leave'),
                    //     key: "assign_leave",
                    //     modifier: (row) => this.$can('assign_leaves')
                    //         && row.employment_status?.alias !== 'terminated'
                    //         && row.status.name !== 'status_inactive'
                    // },
                    // {
                    //     title: this.$t('cancel_invitation'),
                    //     key: "cancel_invitation",
                    //     icon: 'x-circle',
                    //     modalClass: 'danger',
                    //     modifier: row => {
                    //         if (row.status) {
                    //             return row.status.name === 'status_invited';
                    //         }
                    //     },
                    // },
                    // {
                    //     title: this.$t('add_salary'),
                    //     key: 'add_or_edit_salary',
                    //     modifier: row => this.$can('add_salary') && !row.updated_salary &&
                    //         (row.employment_status && row.employment_status.alias !== 'terminated'),
                    // },
                    // {
                    //     title: this.$t('edit_salary'),
                    //     key: 'add_or_edit_salary',
                    //     modifier: row => this.$can('edit_salary') && row.updated_salary &&
                    //         (row.employment_status && row.employment_status.alias !== 'terminated'),
                    // },
                    // {
                    //     title: this.$t('add_joining_date'),
                    //     key: 'add_joining_date',
                    //     modifier: row => this.$can('update_employee_job_history') && !row.profile?.joining_date &&
                    //         (row.employment_status && row.employment_status.alias !== 'terminated'),
                    // },
                    // {
                    //     title: this.$t('add_line_manager'),
                    //     key: 'add_line_manager',
                    //     modifier: row => this.$can('update_employee_line_manager') && row.line_manager &&
                    //         (row.employment_status && row.employment_status.alias !== 'terminated'),
                    // },
                    {
                        title: this.$t('deactivate'),
                        key: "deactivate",
                        modalClass: 'danger',
                        icon: 'x-circle',
                        modifier: row => {
                            if (row.active) {
                                return this.$can('update_tenants');
                            }
                        },
                    },
                    {
                        title: this.$t('activate'),
                        key: "activate",
                        modalClass: 'primary',
                        icon: 'check-circle',
                        modifier: row => {
                            if (!row.active) {
                                return this.$can('update_tenants');
                            }
                        },
                    },
                    // {
                    //     title: this.$t('rejoining'),
                    //     key: "rejoining",
                    //     icon: 'log-in',
                    //     modalClass: 'primary',
                    //     modifier: row => {
                    //         if (row.employment_status) {
                    //             return row.employment_status.alias === 'terminated';
                    //         }
                    //     },
                    // },
                    // {
                    //     title: this.$t('remove_from_employee_list'),
                    //     key: 'remove_from_employee',
                    //     modifier: row => parseInt(row.is_in_employee) && !this.$isOnlyDepartmentManager() &&
                    //         (row.id !== window.user.id || this.$isAdmin())
                    // }
                ],
                rowLimit: 10,
                paginationType: "pagination"
            },
            // selectedEmployees: [],
            selectedTenants: [],
            isContextMenuOpen: false,
            // tenant: {},
        }
    },
    watch: {
        isModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        },
        isTenantCreateOpenModalActive: function (value) {
            if (!value) {
                this.selectedUrl = '';
            }
        },
    },
    methods: {
        getSelectedRows(data, isSelectedAll) {
            this.selectedTenants = data;
            this.isContextMenuOpen = data.length;
        },
        openResourceModal(rowId) {
            console.log(rowId);
        },
        triggerActions(row, action, active) {

            this.promptIcon = action.icon;
            this.tenantId = row.id;
            this.modalClass = action.modalClass;

            if (action.key === 'edit') {
                this.isModalActive = true;
                this.isTenantCreateOpenModalActive = true
                this.selectedUrl = `${action.url}/${row.id}`;
                // console.log(this.selectedUrl);
            }
            if (action.key === 'activate') {
                this.confirmationModalActive = true;
                this.promptAction = action.key;
                this.promptTitle = this.$t('are_you_sure');
                this.promptMessage = this.$t('you_are_going_to_activate_a_tenant');
            }
            else if (action.key === 'deactivate') {
                this.confirmationModalActive = true;
                this.promptAction = action.key;
                this.promptTitle = this.$t('are_you_sure');
                this.promptMessage = this.$t('you_are_going_to_deactivate_a_tenant');
            }


        },
        triggerConfirm() {
            if (this.promptAction === 'activate') {
                this.activateTenant();
            }
            if (this.promptAction === 'deactivate') {
                this.deactivateTenant();
            }
        },
        closeConfirmation() {
            $("#app-confirmation-modal").modal('hide');
            $(".modal-backdrop").remove();
            this.loading = false;
            this.confirmationModalActive = false;
        },
        cancelInvitation() {
            // this.loading = true;
            // axiosDelete(`${EMPLOYEES}/${this.employeeId}/cancel-invitation`).then(({data}) => {
            //     this.confirmationModalActive = false;
            //     this.toastAndReload(data.message, 'employee-table');
            // }).catch(({data}) => {
            //     this.confirmationModalActive = false;
            //     this.toastAndReload(data.message, 'employee-table');
            // }).finally(() => this.closeConfirmation());
        },
        activateTenant() {
            this.loading = true;
            axiosPost(`${TENANTS}/${this.tenantId}/activate`).then(({data}) => {
                this.confirmationModalActive = false;
                this.toastAndReload(data.message, 'tenant-table');
                // setTimeout(() => {
                //     this.isTerminationReasonModalActive = true;
                // })
            }).catch(({data}) => {
                this.confirmationModalActive = false;
                this.toastAndReload(data.message, 'tenant-table');
            }).finally(() => this.closeConfirmation());
        },
        deactivateTenant() {
            this.loading = true;
            axiosPost(`${TENANTS}/${this.tenantId}/deactivate`).then(({data}) => {
                this.confirmationModalActive = false;
                this.toastAndReload(data.message, 'tenant-table');
                // setTimeout(() => {
                //     this.isTerminationReasonModalActive = true;
                // })
            }).catch(({data}) => {
                this.confirmationModalActive = false;
                this.toastAndReload(data.message, 'tenant-table');
            }).finally(() => this.closeConfirmation());
        },
        active() {
            // this.loading = true;
            // axiosPatch(`${EMPLOYEES}/${this.employeeId}/terminate`).then(({data}) => {
            //     this.confirmationModalActive = false;
            //     this.toastAndReload(data.message, 'employee-table');
            //     setTimeout(() => {
            //         this.isTerminationReasonModalActive = true;
            //     })
            // }).catch(({data}) => {
            //     this.confirmationModalActive = false;
            //     this.toastAndReload(data.message, 'employee-table');
            // }).finally(() => this.closeConfirmation());
        },
        rejoining() {
            // this.confirmationModalActive = false;
            // this.employmentStatusModalActive = true;
        },
        reloadTenantTable() {
            this.$hub.$emit('reload-tenant-table');
        },
        removeEmployee() {
            // this.loading = true;
            // axiosPatch(`${TENANT_USERS}/${this.employeeId}/remove-from-employee`)
            //     .then(({data}) => {
            //         this.confirmationModalActive = false;
            //         this.toastAndReload(data.message, 'employee-table')
            //     }).catch(({response}) => {
            //     this.toastException(response.data)
            //     this.confirmationModalActive = false;
            // }).finally(() => this.closeConfirmation());
        }
    },
    mounted() {
        this.$hub.$on('getTenantAction', (row, action, active) => {
            this.triggerActions(row, action, active)
        })
    },
}
